import collectiveApi from 'modules/common/collectiveApi';

export interface TrustpilotSurveyResponse {
    url: string;
}

export const fetchTrustpilotSurvey = async (): Promise<TrustpilotSurveyResponse> => {
    const { data } = await collectiveApi.post<TrustpilotSurveyResponse>('/surveys/trustpilot-unique-link/');
    return data;
};
